import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import {} from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './aidas-customer.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const AidasCustomerDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const aidasCustomerEntity = useAppSelector(state => state.aidasCustomer.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="aidasCustomerDetailsHeading">AidasCustomer</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{aidasCustomerEntity.id}</dd>
          <dt>
            <span id="name">Name</span>
          </dt>
          <dd>{aidasCustomerEntity.name}</dd>
          <dt>
            <span id="description">Description</span>
          </dt>
          <dd>{aidasCustomerEntity.description}</dd>
          <dt>Aidas Organisation</dt>
          <dd>{aidasCustomerEntity.aidasOrganisation ? aidasCustomerEntity.aidasOrganisation.name : ''}</dd>
        </dl>
        <Button tag={Link} to="/aidas-customer" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/aidas-customer/${aidasCustomerEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default AidasCustomerDetail;
